/**
 * Whether the link-your-chess-account modal (components/UsernameLink) is up.
 * - `requested`: the player asked for it (the account menu's Change / Link account, Profile's Edit). Shows on any page:
 *   the account menu is on every page, and its Change used to do nothing on four of them.
 * - `auto`: the first-sign-in nudge for an account with nothing linked. Held back where it would hijack the page.
 */
export type LinkPrompt = "none" | "auto" | "requested";

// Review and Play are mid-task, Library has its inline LinkAccountCard. Not the home (#301, 2026-10-18): a new account
// signed up on `/` was shown the signed-out landing, whose username box lists a player's games but links nothing, so
// nothing on the page led to its own home. Signed out, `auto` never fires (useChessUsername).
const AUTO_HELD_BACK: ReadonlySet<string> = new Set(["/analyze", "/play", "/library"]);

export function linkModalVisible(prompt: LinkPrompt, pathname: string): boolean {
  switch (prompt) {
    case "requested":
      return true;
    case "auto":
      return !AUTO_HELD_BACK.has(pathname);
    case "none":
      return false;
  }
}
